import { cn } from '@/lib/utils';
interface GlowProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: 'brightness' | 'lightness' | 'custom';
}

export default function Glow(props: GlowProps) {
  const { type = 'brightness', className, ...rest } = props;

  return (
    <div
      aria-hidden={true}
      className={cn(
        'pointer-events-none absolute block rounded-full',
        [
          (type === 'brightness' || type === 'lightness') &&
            'h-[467px] w-[467px] md:h-[1229px] md:w-[1229px]',
          type === 'brightness' && ['blur-[200px]', 'bg-primary-600'],
          type === 'lightness' && [
            'glow-lightness',
            '2xl:h-[1500px] 2xl:w-[1500px]',
            'blur-[80px] sm:blur-[120px] 2xl:blur-[250px]',
            'top-0 sm:-top-40 md:-top-[600px] 2xl:-top-[600px]',
            '-right-60 md:-right-[600px] 2xl:-right-[750px]',
            'bg-primary-100',
            'z-0',
          ],
          type === 'custom' && [
            'h-[800px] w-[800px] md:h-[1229px] md:w-[1229px] lg:h-[1229px] 2xl:h-[1800px] 2xl:w-[1800px]',
            'blur-[200px] md:blur-[250px] lg:blur-[250px] 2xl:blur-[500px]',
          ],
        ],
        className,
      )}
      {...rest}
    />
  );
}
